import { render } from "./OrderButton.vue?vue&type=template&id=7d6ab9b4&scoped=true"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"

import "./OrderButton.vue?vue&type=style&index=0&id=7d6ab9b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6ab9b4"]])

export default __exports__